import React from 'react';
import loadable from '@loadable/component';
import { addReducer } from '../../../../../common/store';

const RegisterFormComponent = loadable(() => import('./RegisterForm.container'));

export const RegisterForm = (props) => {
	import('redux-form').then(({ reducer }) => addReducer('form', reducer));

	return <RegisterFormComponent {...props} />;
};
